import React, { useCallback, useMemo } from 'react';
import { Col } from 'react-bootstrap';
import { Scope } from '@unform/core';
import Input from '../../../../components/Input';
import Toggle from '../../../../components/Exame/Toggle';
import SelectSync from '../../../../components/SelectSync';
import { optionsHorasCadastroAgenda } from '../../../../utils/funcoes';

// import { Container } from './styles';
type Props = {
  dia: string;
  nDia: number;
};
const Horario: React.FC<Props> = ({ dia, nDia }) => {
  const optionsHora = useMemo(() => {
    return optionsHorasCadastroAgenda();
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <>
      <Scope path={`horarios[${nDia - 1}]`}>
        <Col>
          <div
            style={{
              width: '88px',
              float: 'left',
              padding: '10px 0',
              textAlign: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Input
                type="hidden"
                className="d-none"
                name="HorDia"
                defaultValue={`${nDia}`}
              />
              <Toggle
                nome="selecionado"
                classSpam={{ paddingRight: '5px' }}
                label={dia}
                isDisabled={false}
              />
            </div>
            <SelectSync
              name="HorHoraIni"
              options={optionsHora}
              handleSelectChange={handleOnChangeVazio}
              placeholder="00:00"
              label=""
              className="pb-1"
            />

            <SelectSync
              name="HorIntervaloIni"
              options={[{ label: '00:00', value: '' }, ...optionsHora]}
              handleSelectChange={handleOnChangeVazio}
              placeholder="00:00"
              label=""
            />

            <SelectSync
              name="HorIntervaloFim"
              options={[{ label: '00:00', value: '' }, ...optionsHora]}
              handleSelectChange={handleOnChangeVazio}
              placeholder="00:00"
              label=""
              className="pb-2"
            />

            <SelectSync
              name="HorHoraFim"
              options={optionsHora}
              handleSelectChange={handleOnChangeVazio}
              placeholder="00:00"
              label=""
              className="pb-2"
            />

            <Input
              name="HorMaxAgendamento"
              label=""
              type="number"
              step="1"
              max="100"
              min="0"
            />
          </div>
        </Col>
      </Scope>
    </>
  );
};

export default Horario;
